var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dot",
    clipPath: "url(#clip0_926_1156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.88 10.1102C28.87 12.0602 30.87 13.4102 33.21 13.4102C36.52 13.4102 39.21 10.7302 39.21 7.41016C39.21 4.09016 36.53 1.41016 33.21 1.41016C29.89 1.41016 27.21 4.09016 27.21 7.41016C27.21 8.39016 27.47 9.29016 27.88 10.1102Z",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.88 30.8391C27.47 31.6491 27.21 32.5591 27.21 33.5391C27.21 36.8491 29.89 39.5391 33.21 39.5391C36.53 39.5391 39.21 36.8591 39.21 33.5391C39.21 30.2191 36.53 27.5391 33.21 27.5391C30.87 27.5391 28.87 28.8891 27.88 30.8391Z",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.7402 17.7805C11.7502 15.8305 9.75016 14.4805 7.41016 14.4805C4.10016 14.4805 1.41016 17.1605 1.41016 20.4805C1.41016 23.8005 4.09016 26.4805 7.41016 26.4805C9.75016 26.4805 11.7502 25.1305 12.7402 23.1805",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.7402 17.7812C13.1502 18.5913 13.4102 19.5012 13.4102 20.4812C13.4102 21.4612 13.1502 22.3612 12.7402 23.1812",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.7402 23.1719L27.8802 30.8419",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.7402 17.7794L27.8802 10.1094",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_926_1156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.62,
    height: 40.95,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon_share.1dbf195805b3fd1ee4c341052896df66.svg";
export { ForwardRef as ReactComponent };